export const initFacetTweaks = () => {
	initTableFilter();
	facetReset();
};

const initTableFilter = () => {
	if (document.querySelector("#industry-sector-filter")) {
		const select = document.querySelector("#industry-sector-filter");

		// add class to container of this filter
		select.closest("th").classList.add("table-filter");

		// add listener to this select element and just console out if it changes for now
		select.addEventListener("change", function (e) {
			let facetWPSelect = document.querySelector(".facetwp-facet-table_industry_sector_sort select");
			if (facetWPSelect) {
				facetWPSelect.value = e.target.value;
				jQuery(".facetwp-facet-table_industry_sector_sort select").trigger("change");
				// facetWPSelect.dispatchEvent(new Event("change"));
			}
		});

		setTimeout(function () {
			// get the same value on select as the facetwp select
			let facetWPSelect = document.querySelector(".facetwp-facet-table_industry_sector_sort select");
			if (facetWPSelect) {
				select.value = facetWPSelect.value;
			}
		}, 300);
	}
};

const facetReset = () => {
	// simulate a click on ".facetwp-type-pager .first"
	const firstPager = document.querySelector(".facetwp-type-pager .first");
	if (firstPager) {
		firstPager.click();
	}

	jQuery(".facetwp-facet-table_industry_sector_sort").on("change", function (e) {
		setTimeout(function () {
			document.querySelector("#industry-sector-filter").value = e.target.value;
			initTableFilter();
		}, 300);
	});
	jQuery(".facetwp-type-pager").on("click", function (e) {
		console.log("thangz done changed");
		setTimeout(function () {
			document.querySelector("#industry-sector-filter").value = e.target.value;
			initTableFilter();
		}, 300);
	});
};
